import styleInject from '../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".desktop-step-indicator-step:first-child,.swan-step-indicator li:first-child{margin-left:0!important}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
